const MENSAJE_GENERICO = 'Error al registrar usuario. Intenta nuevamente.';

/**
 * Saca el motivo que mandó el backend al crear el usuario, para mostrárselo al
 * usuario en vez de un texto genérico.
 *
 * Hay que mirar dos formas distintas porque conviven dos backends:
 *
 *  - wallet-back (serverless) responde `{ error: "Este documento de identidad ya
 *    se encuentra en uso" }`. Angular deja ese body en `err.error`, así que el
 *    texto queda en `err.error.error`. Leerlo como `err.error.message` —que es
 *    lo que se hacía— daba siempre `undefined`, y el usuario veía el genérico y
 *    reintentaba en loop sin saber que su documento ya estaba registrado.
 *  - Nest responde `{ message: "..." }`, que es la forma del resto de la app.
 *
 * Solo se devuelve texto: un 500 de wallet-back contesta con el objeto de error
 * serializado, que no es algo para mostrarle a nadie.
 */
export function mensajeDeErrorDeRegistro(err: any): string {
  const candidatos = [err?.error?.error, err?.error?.message, err?.message];

  for (const candidato of candidatos) {
    if (typeof candidato === 'string' && candidato.trim().length > 0) {
      return candidato.trim();
    }
  }

  return MENSAJE_GENERICO;
}
